import { MDBBtn, MDBDropdown, MDBDropdownToggle, MDBDropdownItem, MDBDropdownMenu } from 'mdb-vue-ui-kit';

export default {
    name: 'DownloadData',
    emits: ['print','print-matrix-only','download-csv'],
    components: {MDBBtn,MDBDropdown, MDBDropdownToggle, MDBDropdownItem, MDBDropdownMenu },
    data() {
        return { dropdown1: false }
    },
    methods: {
        onPrintAll() { this.$emit('print') },
        onPrintMatrixOnly() { this.$emit('print-matrix-only') },
        onDownloadCsv() { this.$emit('download-csv') },
    }
}